import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TeamMembership} from '../../../../../types/team-management.type';
import {AuthService} from '../../../../../auth/shared/services/auth.service';
import {TeamManagementService} from '../../../../../services/api/team-management.service';
import {Router} from '@angular/router';
import {getFirstLetters} from '../../../../../common/utils/helpers';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '../../../../../common/directives/directives.module';
import {ImgCacheBusterDirective} from '../../../../../directives/img-cache-buster';

@Component({
  selector: 'mc-team-item',
  standalone: true,
  imports: [CommonModule, DirectivesModule, ImgCacheBusterDirective],
  templateUrl: './team-item.component.html',
  styleUrl: './team-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamItemComponent {
  team = input<TeamMembership>();
  userId = input<string>();

  switchToTeam = output<TeamMembership>();

  constructor(
    public teamManagementService: TeamManagementService,
    public authService: AuthService,
    public router: Router,
  ) {}

  get isActive() {
    return (
      this.team().myMembershipTeamOwnerAccountId === this.authService.uWTargetSwitchId ||
      (!this.authService.uWTargetSwitchId && this.team().myMembershipTeamOwnerAccountId === this.userId())
    );
  }

  getShortName(name: string) {
    return getFirstLetters(name).slice(0, 2);
  }

  onSwitchToTeam(team: TeamMembership) {
    this.switchToTeam.emit(team);
  }
}
